module.exports = __webpack_public_path__ + "img/BlinkArt_Wand_Medium.741c3be6.png";